<template>
    <a-form
        :form="folderForm"
        layout="vertical"
        class="folder-form"
    >
        <a-form-item 
            :label="`${folderType} kategóriája:`"
        >
            <a-checkbox
                v-decorator="[
                    'isEmphasized',
                    {
                        valuePropName: 'checked',
                        initialValue: false,
                        preserve: true,
                        rules: [
                            {
                                required: true,
                                message: 'Kérjük válasszon',
                            }
                        ]
                    }
                ]"
            >
                Kiemelt?
            </a-checkbox>
        </a-form-item>
        <a-form-item
            :label="`${folderType} neve`"
        >
            <a-textarea
                v-decorator="[
                    'name',
                    {
                        preserve: true,
                        rules: [{
                            required: true,
                            preserve: true,
                            message: 'Kérjük, töltse ki.'
                        }]
                    }
                ]"
                :autosize="{
                    minRows: 3
                }"
                :placeholder="`${folderType} neve`"
            />
        </a-form-item>
        <a-form-item
            :label="`${folderType} leírása`"
        >
            <a-textarea
                v-decorator="[
                    'description',
                    {
                        preserve: true,
                        rules: [{
                            required: true,
                            preserve: true,
                            message: 'Kérjük, töltse ki.'
                        }]
                    }
                ]"
                :autosize="{
                    minRows: 3
                }"
                :placeholder="`${folderType} leírása`"
            />
        </a-form-item>
        <template
            v-if="folderType === 'akta'"
        >
            <a-divider></a-divider>
            <a-form-item
                
                :label="`${folderType} összegzése`"
            >
                <a-textarea
                    v-decorator="[
                        'overall',
                        {
                            preserve: true,
                            rules: [{
                                required: false,
                                preserve: true,
                                message: 'Kérjük, töltse ki.'
                            }]
                        }
                    ]"
                    :autosize="{
                        minRows: 3
                    }"
                    :placeholder="`${folderType} összegzése`"
                />
            </a-form-item>
        </template>
        <a-divider
            orientation="left"
        >
            Címkék:
        </a-divider>
        <TagsSearchSelectWrapper
            v-model="persons"
            tagType="person"
            label="Kiről szól?"
        />
        <a-divider></a-divider>
        <TagsSearchSelectWrapper 
            tagType="topic"
            label="Témakör"
            v-model="topics"
        />
        <a-divider></a-divider>
        <TagsSearchSelectWrapper 
            tagType="other"
            label="Egyéb címkék"
            v-model="tags"
        />
        <template
            v-if="folderType !== 'akta'"
        >
            <a-divider></a-divider>
            <SearchSlider 
                v-model="priority"
                :max="5"
                :min="1"
                label="Prioritás"
            />
        </template>
        
    </a-form>
</template>

<script>
import TagsSearchSelectWrapper from '@/components/app/search_components/TagsSearchSelectWrapper.vue';
import SearchSlider from '@/components/app/search_components/SearchSlider.vue';

export default {
    name: 'FolderForm',

    components: {
        TagsSearchSelectWrapper,
        SearchSlider
    },

    props: {
        folderType: {
            type: String,
            default: 'akta'
        },
        formData: {
            type: Object
        }
    },

    created() {
        this.folderForm = this.$form.createForm(this, {
            mapPropsToFields: () => {
                const formKeys = Object.keys(this.formData);
                const fields = formKeys.reduce((formFields, key) => {
                    formFields[key] = this.$form.createFormField({
                        ...this.formData[key],
                        value: this.formData[key]
                    })
                    return formFields;
                }, {})
                return fields;
            },
            onValuesChange: (_, values) => {
                this.$emit('valuesChange', values);
            }
        })
    },

    computed: {
        persons: {
            get() {
                return this.formData.persons
            }, 
            set(val) {
                this.$emit('valuesChange', {
                    persons: val
                })
            }
        },
        topics: {
            get() {
                return this.formData.topics
            }, 
            set(val) {
                this.$emit('valuesChange', {
                    topics: val
                })
            }
        },
        tags: {
            get() {
                return this.formData.tags
            }, 
            set(val) {
                this.$emit('valuesChange', {
                    tags: val
                })
            }
        },
        priority: {
            get() {
                return this.formData.priority;
            }, 
            set(val) {
                this.$emit('valuesChange', {
                    priority: val
                })
            }
        }
    },
    methods: {
    }
    
}
</script>

<style lang="scss">
    .folder-form {
        .ant-form-item-label {
            text-transform: capitalize;
        }
    }
    
</style>